<div class="ai-chat-view" [class.completed]="completed$()">
  <div class="ai-chat-view__container">
    <div [@inOutAnimation]="'in'" class="ai-chat-view__question">
      <div class="ai-chat-view__question-icon">
        <fa-icon [icon]="faSparkles"></fa-icon>
      </div>

      <div class="ai-chat-view__question-wrapper">
        @if (stimulusRaw$()) {
          <div class="ai-chat-view__question-wrapper__media">
            <empathy-stimulus [expandable]="true" [stimulus]="[stimulusRaw$()]"></empathy-stimulus>
          </div>
        }
        <span class="survey-viewer__html-content text__md" [innerHTML]="initialQuestion$() || ''"></span>
      </div>
    </div>

    @for (message of messageViews$(); track $index) {
      @if (message.isAssistant) {
        <div [@inOutAnimation]="'in'" class="ai-chat-view__question" [class.new-message]="$last" [scrollToSelected]="'new-message'">
          <div class="ai-chat-view__question-icon">
            <fa-icon [icon]="faSparkles"></fa-icon>
          </div>
          <div class="ai-chat-view__question-wrapper">
            <span class="survey-viewer__html-content text__md" [innerHTML]="message.content"></span>
          </div>
        </div>
      } @else {
        <div [@inOutAnimation]="'in'" class="ai-chat-view__answer" [class.audio]="message.isAudio">
          <div class="ai-chat-view__answer-wrapper">
            @if (message.isAudio) {
              @if (message.audio; as audio) {
                <empathy-local-audio-player [audio]="audio" [id]="message.audioPlayerId"></empathy-local-audio-player>
              } @else {
                <span class="text__md">Audio response</span>
              }
            } @else {
              <span class="text__md">{{ message.content }}</span>
            }
          </div>
        </div>
      }
    }

    @if (pendingAnswerView$(); as answer) {
      <div [@inOutAnimation]="'in'" class="ai-chat-view__answer" [class.audio]="answer.isAudio">
        @if (retryableError$()) {
          <div class="ai-chat-view__question-icon">
            <button mat-icon-button class="eiq-button" color="primary" [attr.data-testid]="'ai-chat-' + question().id + '-retry-button'" (click)="onResend()">
              <fa-icon [icon]="faRepeat"></fa-icon>
            </button>
          </div>
        }
        <div class="ai-chat-view__answer-wrapper">
          @if (answer.isAudio) {
            @if (answer.audio; as audio) {
              <empathy-local-audio-player [audio]="audio" [id]="answer.audioPlayerId"></empathy-local-audio-player>
            } @else {
              <span class="text__md">Audio response</span>
            }
          } @else {
            <span class="text__md">{{ answer.content }}</span>
          }
        </div>
      </div>
    }

    @if (processingAudio$() && !pendingAnswerView$()) {
      <div [@inOutAnimation]="'in'" class="ai-chat-view__answer audio-mock">
        <fa-icon [icon]="faPlay"></fa-icon>
        <div class="audiowave__mock"></div>
      </div>
    }

    @if (sendFailed$()) {
      <span class="ai-chat-view__answer__error text__sm">Failed to send</span>
    }

    @if (waiting$() || processingAudio$()) {
      <div class="ai-chat-view__waiting" [attr.data-testid]="'ai-chat-' + question().id + '-pending-indicator'">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    }

    @if (completed$()) {
      <div [@inOutAnimation]="'in'" class="ai-chat-view__question completed">
        <div class="ai-chat-view__question-icon">
          <fa-icon [icon]="faCommentCheck"></fa-icon>
        </div>
        <div class="ai-chat-view__question-wrapper">
          <span class="survey-viewer__html-content text__md">{{ completedMessage }}</span>
        </div>
      </div>
    }
  </div>

  @if (canAnswer$()) {
    <div [@inOutAnimation]="'in'" class="ai-chat-view__footer">
      <empathy-keyboard-audio
        [allowVoiceResponses]="question().allowVoiceResponsesInd !== false"
        [questionId]="question().id"
        (answerAudio)="onAnswerAudio($event)"
        (answerText)="onAnswer($event)"
        (processing)="onProcessing($event)"
        (transcribeError)="httpError.emit()"
      ></empathy-keyboard-audio>
    </div>
  }
</div>
